import { GetPlayerReturnLossAdminResponse } from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerReturnLoss } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerReturnLoss(
	playerId: string,
	props?: Partial<UseBaseQueryOptions<GetPlayerReturnLossAdminResponse>>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerReturnLoss, playerId],
		queryFn: () => getPlayerReturnLoss(playerId),
		enabled: Boolean(playerId),
		...props,
	})
}
